/* eslint-disable no-magic-numbers */
import React from 'react';
import classNames from 'classnames';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const Grid = _ref => {
  let {
    children,
    itemsPerRow,
    nowrap
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(style.Grid, style["items".concat(itemsPerRow)], {
      [style.nowrap]: Boolean(nowrap)
    }),
    "data-id": "grid_index_Grid_div",
    children: children
  });
};

Grid.defaultProps = {
  nowrap: false,
  itemsPerRow: 2
};
export default Grid;